// extracted by mini-css-extract-plugin
export default {"mobileOnly":"MobileOnly_mobileOnly__gYpdj"};